// Single source for every price label across the product (class-detail upgrade line, the
// paywall, /pricing) so numbers never drift. Keep in sync with the Paystack plan amounts in
// the backend (PaymentService.java PLAN_AMOUNTS: FULL_ACCESS_MONTHLY / _YEARLY).
//
// These are pure price *labels* only — the surrounding words ("/mo", "Save 25%", "billed
// yearly") live in i18n so they stay translatable.
export const MONTHLY_PRICE_LABEL = 'NGN 3,500'
export const YEARLY_PRICE_LABEL = 'NGN 31,500'

// The pre-discount anchor for the yearly strike-through: 12 × monthly (3,500 × 12 = 42,000).
export const YEARLY_WAS_LABEL = 'NGN 42,000'

// Yearly broken down per month, for the "less every month" framing: 31,500 ÷ 12 = 2,625.
export const YEARLY_MONTHLY_EQUIV_LABEL = 'NGN 2,625'
